import Vue from 'vue';
import Router from 'vue-router';
import Applications from '@/views/Applications.vue';
import ApplicationPermissions from '@/views/ApplicationPermissions.vue';
import Customer from '@/views/Customer.vue';
import CustomerLinkedAccounts from '@/views/customer/LinkedAccounts.vue';
import CustomerCreate from '@/views/customer/Create.vue';
import CustomerMsp from '@/views/CustomerMsp.vue';
import Login from '@/views/Login.vue';
import Salesforce from '@/views/Salesforce.vue';
import Search from '@/views/Search.vue';
import Devtool from '@/views/Devtool.vue';
import Storage from '@/storage';
import store from '@/store';
import Route from '@/route';
import Api from '@/api';


Vue.use(Router);

const defaultRouteAuthenticated = Route.SEARCH;
const defaultRouteUnauthenticated = Route.LOGIN;

const routes = [{
    path: Route.SEARCH.path,
    name: Route.SEARCH.name,
    meta: {
        authentication: true,
        neededRoles: Route.SEARCH.neededRoles,
    },
    component: Search,
}, {
    path: Route.LOGIN.path,
    name: Route.LOGIN.name,
    meta: {
        authentication: false,
        neededRoles: Route.LOGIN.neededRoles,
    },
    component: Login,
}, {
    path: Route.CUSTOMER_CREATE.path,
    name: Route.CUSTOMER_CREATE.name,
    meta: {
        authentication: true,
        neededRoles: Route.CUSTOMER_CREATE.neededRoles,
    },
    component: CustomerCreate,
}, {
    path: Route.CUSTOMER_C1.path,
    name: Route.CUSTOMER_C1.name,
    meta: {
        authentication: true,
        neededRoles: Route.CUSTOMER_C1.neededRoles,
    },
    component: Customer,
}, {
    path: Route.CUSTOMER_MSP.path,
    name: Route.CUSTOMER_MSP.name,
    meta: {
        authentication: true,
        neededRoles: Route.CUSTOMER_MSP.neededRoles,
    },
    beforeEnter: (to, from, next) => {
        store.commit('maskView');
        if (['NOZ', 'MHN'].indexOf(to.params.scope) < 0) {
            store.commit('snackbar/info', 'Ungültige SAP Konfiguration.');
            store.commit('demaskView');
            next(false);
        } else {
            store.dispatch('simpleSearch/searchInvisible', {
                undefined,
                gpnumber: to.params.gp_id,
            }).then(({ ssoId, multibleResults }) => {
                if (ssoId) {
                    next({
                        name: Route.CUSTOMER_C1.name,
                        params: {
                            sso_id: ssoId,
                        },
                    });
                } else if (multibleResults) {
                    next({ name: Route.SEARCH.name });
                } else {
                    next();
                }
            }).catch(() => {
                next();
            }).finally(() => {
                store.commit('demaskView');
            });
        }
    },
    component: CustomerMsp,
}, {
    path: Route.DEVTOOL.path,
    name: Route.DEVTOOL.name,
    meta: {
        authentication: true,
        neededRoles: Route.DEVTOOL.neededRoles,
    },
    component: Devtool,
}, {
    path: Route.CUSTOMER_LINKED_ACCOUNTS.path,
    name: Route.CUSTOMER_LINKED_ACCOUNTS.name,
    meta: {
        authentication: true,
        neededRoles: Route.CUSTOMER_LINKED_ACCOUNTS.neededRoles,
    },
    component: CustomerLinkedAccounts,
}, {
    path: Route.APPLICATIONS.path,
    name: Route.APPLICATIONS.name,
    meta: {
        authentication: true,
        neededRoles: Route.APPLICATIONS.neededRoles,
    },
    component: Applications,
}, {
    path: Route.APPLICATION_PERMISSIONS.path,
    name: Route.APPLICATION_PERMISSIONS.name,
    meta: {
        authentication: true,
        neededRoles: Route.APPLICATION_PERMISSIONS.neededRoles,
    },
    component: ApplicationPermissions,
}, {
    path: Route.SALESFORCE.path,
    name: Route.SALESFORCE.name,
    meta: {
        authentication: true,
        neededRoles: Route.SALESFORCE.neededRoles,
    },
    component: Salesforce,
}, {
    path: '*',
    redirect: Route.SEARCH.path,
    meta: {
        authentication: true,
        neededRoles: Route.SEARCH.neededRoles,
    },
}];

const router = new Router({ routes });
let loginControl = null;
const intervalDuration = 1000;

function loginControlFn() {
    const token = Storage.getToken();
    if ((new Date(token.lifetime * 1000)) < (new Date())) {
        Storage.clearToken();
        router.push({ name: defaultRouteUnauthenticated.name });
    }
}

function areUserRolesOk(neededRoles) {
    if (!neededRoles) {
        return false;
    }
    return store.state.userRoles.length > 0
        && neededRoles.some(role => store.state.userRoles.indexOf(role) > -1);
}

router.beforeEach((to, from, next) => {
    const token = Storage.getToken();
    const isTokenValid = (new Date(token.lifetime * 1000)) > (new Date());

    if (isTokenValid) {
        store.dispatch('loadUserRoles').catch(() => null).finally(() => {
            if (!areUserRolesOk(to.meta.neededRoles)) {
                router.replace({ name: defaultRouteAuthenticated.name });
            }
        });
    }

    if (to.meta.authentication && !isTokenValid) {
        next(defaultRouteUnauthenticated.path);
    } else if (!to.meta.authentication && isTokenValid) {
        next(defaultRouteAuthenticated.path);
    } else {
        next();
    }
});


/* eslint-disable-next-line */
router.afterEach((to, from) => {
    const name = from.fullPath || defaultRouteAuthenticated.name;
    store.commit('redirectTo', name);
    clearInterval(loginControl);
    if (to.meta.authentication) {
        Api.auth.renewToken()
            /* eslint-disable-next-line */
            .then(({ data }) => {
                loginControl = setInterval(loginControlFn, intervalDuration);
            })
            /* eslint-disable-next-line */
            .catch((response) => {
                router.push({ name: defaultRouteUnauthenticated.name });
            });
    }
});

export default router;
